import React from 'react'
import './IconStyles.css';
import { RiShieldCheckLine } from "react-icons/ri";

export const HygieneIcon = (props) => (
    <div style={{minWidth: "1.75em"}}>
        <RiShieldCheckLine
            color={props.color ? props.color : undefined}
            size={props.size ? props.size : "1.25em"}
        />
    </div>
)